import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import { Shipping } from '../Shipping'
import type { ShippingOptionArgs } from './ShippingOptionArgs'
import type { ShippingGatewayProvider } from '../ShippingGatewayProvider'

@InputType()
export class CreateShippingArgs extends ActionArgs implements ShippingOptionArgs {
  @Field(() => String)
  rateId?: string

  @Field(() => String)
  shipmentId?: string

  @Field(() => Shipping)
  shipping: Shipping

  @Field(() => Boolean)
  skipCaching?: boolean

  @Field(() => String)
  gatewayProvider: ShippingGatewayProvider
}

export interface ICreateShipping extends IAction<Shipping, CreateShippingArgs> {}
